module.exports = __webpack_public_path__ + "img/multiple-users-wifi.91184e31.svg";